import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Badge, Drawer, SvgIcon, Tooltip } from '@fx-ui/fine-design';
import { platformIntl } from '../../constants';
import { SuiteId } from '@libs/shared';
import useUnreadMessage from './hooks/useUnreadMessage';
import BellIcon from '../../assets/svgicons/bell.svg';
import MessageCenter from '../message-center';

interface NavMessageProps {
    /**
     * 用于区分子产品类型
     */
    suiteId: SuiteId;
    /**
     * 点击消息图标
     */
    onClick?: () => void;
    /**
     * 未读消息红点偏移值
     */
    offset?: [number, number];
}

const NavMessage: React.FC<NavMessageProps> = (props) => {
    const { offset = [-5, -5], onClick, suiteId } = props;
    const [messagePaneVisible, setMessagePaneVisible] = useState<boolean>(false);
    const { hasUnreadMessage, initUnreadMessage } = useUnreadMessage();

    useEffect(() => {
        initUnreadMessage();
    }, []);

    const wrapperBadge = (element: React.ReactElement) => {
        if (!hasUnreadMessage) {
            return element;
        }
        return (
            <Badge dot offset={offset}>
                {element}
            </Badge>
        );
    };

    return (
        <>
            <Tooltip content={platformIntl.get('message')} effect="dark" placement="bottom">
                <div
                    className={classNames('fx-nav-message')}
                    onClick={() => {
                        onClick?.();
                        setMessagePaneVisible(true);
                    }}
                >
                    {wrapperBadge(<SvgIcon component={BellIcon} />)}
                </div>
            </Tooltip>
            <Drawer
                autoClose
                className="fx-nav-message-drawer"
                title={platformIntl.get('message.center')}
                visible={messagePaneVisible}
                placement="right"
                edge={{
                    width: '75%'
                }}
                styles={{
                    header: {
                        textAlign: 'left'
                    }
                }}
                onClose={() => setMessagePaneVisible(false)}
            >
                <MessageCenter suiteId={suiteId} />
            </Drawer>
        </>
    );
};

export default NavMessage;
